export default __webpack_public_path__ + "static/media/screw-inventory.a03be771.jpg";